import { Loader } from "@talkouttech/portal-shared";
import { useAuth } from "context/auth-context";
import { FC, ReactNode, useEffect, useRef, useState } from "react";

interface ForcedLoginProps {
  children: ReactNode;
}

const ForcedLogin: FC<ForcedLoginProps> = ({ children }) => {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const hasResolvedInitialAuth = useRef(false);
  const [isLoginAllowed, setIsLoginAllowed] = useState(false);

  useEffect(() => {
    if (isLoading || hasResolvedInitialAuth.current) {
      return;
    }

    if (isAuthenticated) {
      if (!logout) return;

      hasResolvedInitialAuth.current = true;
      logout();
      return;
    }

    hasResolvedInitialAuth.current = true;
    setIsLoginAllowed(true);
  }, [isAuthenticated, isLoading, logout]);

  if (!isLoginAllowed) {
    return <Loader />;
  }

  return <>{children}</>;
};

export { ForcedLogin };
